<template>
    <div>
        <Comments :data="formData" :showAdminFormLevelControls="adminReview" :hideHistory="true" />
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { usePageStore } from "../pageState/store";
import Comments from "../elementTemplates/Comments.3.vue";
export default defineComponent({
    components: {
        Comments,
    },
    setup() {
        const pageStore = usePageStore();

        return {
            formData: computed(() => pageStore.formData),
            adminReview: computed(() => pageStore.adminReview),
        };
    },
});
</script>
